import { type SearchRequest } from '@searchkit/api';

import { createQueryFactory } from '~/apps/product-plus/search-domain/pipelines/event-overview/query-factory';
import { type SearchDomainContext } from '~/apps/product-plus/search-domain/types';

export function buildEventOverviewQuery(_context: SearchDomainContext, searchRequest: SearchRequest) {
  if (searchRequest.request.type === 'facet') {
    return searchRequest;
  }

  const queryFactory = createQueryFactory();
  return queryFactory(searchRequest);
}
